var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('b-modal',{ref:"notifyModal",attrs:{"title":_vm.notify.title,"size":"md","ok-only":""},on:{"hidden":_vm.onHidden}},[_c('div',{staticClass:"d-block text-center"},[_vm._v("\n      "+_vm._s(_vm.notify.message)+"\n    ")])]),_c('global-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }